'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createContext, useContext, useRef } from 'react';
import { mergeProps, useButton, useDisclosure, useFocusRing, useId } from 'react-aria';
import { useDisclosureGroupState, useDisclosureState, } from 'react-stately';
import { OpenAPISelect, OpenAPISelectItem, useSelectState } from './OpenAPISelect';
var DisclosureGroupStateContext = createContext(null);
/**
 * Display an interactive OpenAPI disclosure group.
 */
export function OpenAPIDisclosureGroup(props) {
    var icon = props.icon, groups = props.groups, selectStateKey = props.selectStateKey, selectIcon = props.selectIcon;
    var state = useDisclosureGroupState(props);
    return (<DisclosureGroupStateContext.Provider value={state}>
            {groups.map(function (group) { return (<DisclosureItem selectStateKey={selectStateKey} selectIcon={selectIcon} icon={icon} key={group.key} group={group}/>); })}
        </DisclosureGroupStateContext.Provider>);
}
function DisclosureItem(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var icon = props.icon, group = props.group, selectStateKey = props.selectStateKey, selectIcon = props.selectIcon;
    var defaultId = useId();
    var id = group.key || defaultId;
    var groupState = useContext(DisclosureGroupStateContext);
    var isExpanded = (groupState === null || groupState === void 0 ? void 0 : groupState.expandedKeys.has(id)) || false;
    var state = useDisclosureState({
        isExpanded: isExpanded,
        onExpandedChange: function () {
            if (groupState) {
                groupState.toggleKey(id);
            }
        },
    });
    var panelRef = useRef(null);
    var triggerRef = useRef(null);
    var isDisabled = (groupState === null || groupState === void 0 ? void 0 : groupState.isDisabled) || !((_a = group.tabs) === null || _a === void 0 ? void 0 : _a.length) || false;
    var _h = useDisclosure(__assign(__assign({}, props), { isExpanded: isExpanded, isDisabled: isDisabled }), state, panelRef), triggerProps = _h.buttonProps, panelProps = _h.panelProps;
    var buttonProps = useButton(triggerProps, triggerRef).buttonProps;
    var _j = useFocusRing(), isFocusVisible = _j.isFocusVisible, focusProps = _j.focusProps;
    var defaultTab = ((_c = (_b = group.tabs) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.key) || '';
    var store = useSelectState(selectStateKey, defaultTab);
    var selectedTab = ((_d = group.tabs) === null || _d === void 0 ? void 0 : _d.find(function (tab) { return tab.key === store.key; })) || ((_e = group.tabs) === null || _e === void 0 ? void 0 : _e[0]);
    return (<div className="openapi-disclosure-group" aria-expanded={state.isExpanded}>
            <div className="openapi-disclosure-group-header">
                <button slot="trigger" ref={triggerRef} {...mergeProps(buttonProps, focusProps)} disabled={isDisabled} style={{
            outline: isFocusVisible
                ? '2px solid rgb(var(--primary-color-500)/0.4)'
                : 'none',
        }} className="openapi-disclosure-group-trigger">
                    <div className="openapi-disclosure-group-icon">
                        {icon || (<svg viewBox="0 0 24 24" className="openapi-disclosure-group-icon">
                                <path d="m8.25 4.5 7.5 7.5-7.5 7.5"/>
                            </svg>)}
                    </div>

                    {group.label}
                </button>
                {group.tabs ? (<div className="openapi-disclosure-group-mediatype" onClick={function (e) { return e.stopPropagation(); }}>
                        {((_f = group.tabs) === null || _f === void 0 ? void 0 : _f.length) > 1 ? (<OpenAPISelect icon={selectIcon} stateKey={selectStateKey} onSelectionChange={function () {
                    state.expand();
                }} items={group.tabs} placement="bottom end">
                                {group.tabs.map(function (tab) { return (<OpenAPISelectItem key={tab.key} id={tab.key} value={tab}>
                                        {tab.label}
                                    </OpenAPISelectItem>); })}
                            </OpenAPISelect>) : ((_g = group.tabs[0]) === null || _g === void 0 ? void 0 : _g.label) ? (<span>{group.tabs[0].label}</span>) : null}
                    </div>) : null}
            </div>

            {state.isExpanded && selectedTab && (<div className="openapi-disclosure-group-panel" ref={panelRef} {...panelProps}>
                    {selectedTab.body}
                </div>)}
        </div>);
}
